import { CustomerCompanyMessage } from '../../../types/CustomerCompanyMessage';
import { Text } from '../../cdl/Text/Text';
import { DataSheet } from '../DataSheet/DataSheet';
import { formatAddress } from '../helpers/formatAddress.helper';
import { translate } from '../helpers/translate.helper';

import { CoreDataPopup } from './CoreDataPopup';

interface CustomerInfoPopupProps {
    customer: CustomerCompanyMessage;
    isSpot: boolean;
    isEnquiry: boolean;
}

export const CustomerInfoPopup = ({ customer, isSpot, isEnquiry }: CustomerInfoPopupProps) => {
    const createWording = (content: string | null) => {
        if (!isEnquiry || !isSpot) {
            return content;
        }

        return isSpot
            ? translate('offer.detail.coreData.customerPopup.emailAddressNotAvailableSpot')
            : translate('offer.detail.coreData.customerPopup.emailAddressNotAvailableContracted');
    };

    return (
        <CoreDataPopup heading={translate('offer.detail.coreData.customerPopup.headline')}>
            <DataSheet>
                <DataSheet.Label>{translate('offer.detail.coreData.customerPopup.name')}</DataSheet.Label>
                <Text>{customer.name}</Text>

                {customer.email ? (
                    <>
                        <DataSheet.Label>
                            {translate('offer.detail.coreData.customerPopup.emailAddress')}
                        </DataSheet.Label>
                        <Text>{createWording(customer.email)}</Text>
                    </>
                ) : null}

                {customer.phone ? (
                    <>
                        <DataSheet.Label>
                            {translate('offer.detail.coreData.customerPopup.phoneNumber')}
                        </DataSheet.Label>
                        <Text>{createWording(customer.phone)}</Text>
                    </>
                ) : null}

                {customer.address ? (
                    <>
                        <DataSheet.Label>{translate('offer.detail.coreData.customerPopup.address')}</DataSheet.Label>
                        <Text>{createWording(formatAddress({ address: customer.address }))}</Text>
                    </>
                ) : null}
            </DataSheet>
        </CoreDataPopup>
    );
};
